// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__+nahC","PageSelect":"Pagination_PageSelect__XRE1J"};